<template>

  <v-flex>
    <v-layout align-center="align-center">
      <transition name="slide">
        <v-flex xs2="xs2" v-if="dateRange">
          <v-subheader>From</v-subheader>
        </v-flex>
      </transition>
      <v-flex>
        <DateSearchInput v-model="from"></DateSearchInput>
      </v-flex>
      <v-flex xs2="xs2">
        <v-icon medium="medium" @click="dateRange = !dateRange">{{ dateRange ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
      </v-flex>
    </v-layout>
    <TransitionExpand>
      <v-layout align-center="align-center" v-if="dateRange">
        <v-flex xs2="xs2">
          <v-subheader>To</v-subheader>
        </v-flex>
        <v-flex>
          <DateSearchInput v-model="to"></DateSearchInput>
        </v-flex>
        <v-flex xs2="xs2"></v-flex>
      </v-layout>
    </TransitionExpand>
  </v-flex>

</template>

<script>

import DateSearchInput from '@/components/common/DateSearchInput'
import TransitionExpand from '@/components/TransitionExpand'

export default {
  name: 'DateSearch',
  components: {
    DateSearchInput,
    TransitionExpand
  },
  props: ['value'],
  data () {
    return {
      from: null,
      to: null,
      dateRange: true
    }
  },
  methods: {
    emit (from, to) {
      this.$emit('input', {from, to})
    },
    update () {
      if (!this.dateRange) {
        this.emit(this.from, this.from)
        return
      }

      this.emit(this.from, this.to)
    }
  },
  watch: {
    from () {
      this.update()
    },
    to () {
      this.update()
    },
    dateRange () {
      this.update()
    }
  }
}

</script>

<style lang="scss" scoped>

  .slide-enter-active, .slide-leave-active {
    transition: all .5s ease;
  }

  .slide-enter-to, .slide-leave {
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    max-width: 0px;
    margin-bottom: 0px;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/DateSearch.vue